import { UserRoles } from "../storage/enums";

function defaultHandleError({ data }) {
  return Object.values(data)
    .flat()
    .map((c) => c);
}

function defaultHandleResponse({ data }) {
  return data;
}

export const ApiEndpoints = {
  captcha: {
    get: {
      url: "user/captcha/",
      isAnonymous: true,
      config: {
        method: "GET",
      },
      handleResponse({ data }) {
        return data;
      },
      handleError: defaultHandleError,
    },
  },
  user: {
    stateList: {
      url: "user/crm/state",
      isAnonymous: true,
      config: {
        method: "GET",
      },
      handleResponse({ data }) {
        return data;
      },
      handleError: defaultHandleError,
    },
    cityList: {
      url: "user/crm/city",
      isAnonymous: true,
      config: {
        method: "GET",
      },
      handleResponse({ data }) {
        return data;
      },
      handleError: defaultHandleError,
    },
    departmentList: {
      url: "user/crm/majmooe",
      isAnonymous: true,
      config: {
        method: "GET",
      },
      handleResponse({ data }) {
        return data;
      },
      handleError: defaultHandleError,
    },
    organizationList: {
      url: "user/crm/sazman",
      isAnonymous: true,
      config: {
        method: "GET",
      },
      handleResponse({ data }) {
        return data.map((c) => ({
          ...c,
          department: c.majmooe,
        }));
      },
      handleError: defaultHandleError,
    },
    userUpdateGet: {
      url: ({ userId }) => `user/update/${userId}/`,
      config: {
        method: "GET",
      },
      input({ userId }) {
        return {
          urlParams: {
            userId,
          },
        };
      },
      handleResponse({ data }) {
        return data;
      },
      handleError: defaultHandleError,
    },
    userUpdate: {
      url: ({ userId }) => `user/update/${userId}/`,
      config: {
        method: "PUT",
      },
      input({
        mobileNumber,
        fullName,
        userTypeId,
        dastgahType,
        sakhtarDastgahType,
        moavenat,
        state,
        cityId,
        majmooeId,
        sazmanId,
        userId,
      }) {
        return {
          urlParams: {
            userId,
          },
          body: {
            mobile_number: mobileNumber,
            full_name: fullName,
            user_type: userTypeId,
            dastgah_type: dastgahType,
            sakhtar_dastgah_tabee_type: sakhtarDastgahType,
            moavenat: moavenat,
            state: state,
            city: cityId,
            majmooe: majmooeId,
            sazman: sazmanId,
          },
        };
      },
      handleResponse() {
        return {};
      },
      handleError: defaultHandleError,
    },
    userPartialUpdate: {
      url: ({ userId }) => `user/update/${userId}/`,
      config: {
        method: "PATCH",
      },
      input({ userType, userId }) {
        return {
          urlParams: {
            userId,
          },
          body: {
            user_type: userType,
          },
        };
      },
      handleResponse() {
        return {};
      },
      handleError: defaultHandleError,
    },
    profile: {
      url: "user/profile/",
      config: {
        method: "GET",
      },
      handleResponse({ data }) {
        const roleIndex = Object.values(UserRoles).findIndex(
          (c) => c === data.user_type,
        );
        const role =
          roleIndex === -1
            ? UserRoles.UnKnown
            : UserRoles[Object.keys(UserRoles)[roleIndex]];
        return {
          id: data.id,
          phoneNumber: data.mobile_number,
          landlineNumber: data.phone_number,
          fullName: data.full_name,
          state: data.state,
          city: data.city,
          role,
          sectionType: data.dastgah_type,
          structureType: data.sakhtar_dastgah_tabee_type,
          assistance: data.moavenat,
          department: data.majmooe,
          organization: data.sazman,
          lastLogin: data.last_login,
        };
      },
      handleError: defaultHandleError,
    },
    updateProfile: {
      url: ({ userId }) => `user/user-account/${userId}/`,
      config: {
        method: "PATCH",
      },
      input({
        phoneNumber,
        landlineNumber,
        fullName,
        sectionType,
        structureType,
        assistance,
        state,
        city,
        department,
        organization,
        userId,
      }) {
        return {
          urlParams: {
            userId,
          },
          body: {
            mobile_number: phoneNumber,
            phone_number: landlineNumber,
            full_name: fullName,
            dastgah_type: sectionType,
            sakhtar_dastgah_tabee_type: structureType,
            moavenat: assistance,
            state: state,
            city: city,
            majmooe: department,
            sazman: organization,
          },
        };
      },
      handleResponse() {
        return {};
      },
      handleError: defaultHandleError,
    },
    requestOtp: {
      url: "user/otp/generate/",
      isAnonymous: true,
      config: {
        method: "POST",
      },
      input({ phoneNumber, captchaKey, captchaValue }) {
        return {
          body: {
            mobile_number: phoneNumber,
            captcha_key: captchaKey,
            captcha_value: captchaValue,
          },
        };
      },
      error: {
        mobile_number_must_11_digits: "شماره تلفن باید ۱۱ رقم باشد",
        You_requested_in_last_90_sec:
          "برای دریافت مجدد کد باید ۹۰ ثانیه صبر کنید",
        "Invalid captcha": "کد امنیتی وارد شده صحیح نمی باشد",
      },
      handleResponse({ data }) {
        return {
          phoneNumber: data.mobile_number,
          otpCode: data.otp_code,
          isUserNotFound: data.status === "user_not_found",
          isUserForceUpdateProfile: data.status === "user_need_update_profile",
        };
      },
      handleError: defaultHandleError,
    },
    verifyOtp: {
      url: "user/otp/verify/",
      isAnonymous: true,
      config: {
        method: "POST",
      },
      input({ phoneNumber, otpCode }) {
        return {
          body: {
            mobile_number: phoneNumber,
            otp: otpCode,
          },
        };
      },
      error: {
        "invalid_OTP.": "کد وارد شده صحیح نیست",
      },
      handleResponse({ data }) {
        return {
          accessToken: data.access,
          refreshToken: data.refresh,
          userId: data.user_id,
        };
      },
      handleError: defaultHandleError,
    },
    verifyNewOtp: {
      url: "user/otp/new-user-verify/",
      isAnonymous: true,
      config: {
        method: "POST",
      },
      input({ phoneNumber, otpCode }) {
        return {
          body: {
            mobile_number: phoneNumber,
            otp: otpCode,
          },
        };
      },
      error: {
        "invalid_OTP.": "کد وارد شده صحیح نیست",
      },
      handleResponse({ data }) {
        return {
          accessToken: data.access,
          refreshToken: data.refresh,
        };
      },
      handleError: defaultHandleError,
    },
    signup: {
      url: "user/user-account/",
      isAnonymous: true,
      config: {
        method: "POST",
      },
      input({
        phoneNumber,
        landlineNumber,
        fullName,
        sectionType,
        structureType,
        assistance,
        state,
        city,
        department,
        organization,
      }) {
        return {
          body: {
            mobile_number: phoneNumber,
            phone_number: landlineNumber,
            full_name: fullName,
            dastgah_type: sectionType,
            sakhtar_dastgah_tabee_type: structureType,
            moavenat: assistance,
            state: state,
            city: city,
            majmooe: department,
            sazman: organization,
          },
        };
      },
      error: {
        "invalid_OTP.": "کد وارد شده صحیح نیست",
      },
      handleResponse({ data }) {
        return {
          accessToken: data.access,
          refreshToken: data.refresh,
        };
      },
      handleError: defaultHandleError,
    },
    listByAdmin: {
      url: "user/user-list-v2/",
      config: {
        method: "GET",
      },
      input({
        page,
        userId,
        sazman_id,
        city_id,
        state_id,
        majmooe_id,
        search,
        userType,
      }) {
        return {
          params: {
            page: page,
            id: userId,
            sazman_id: sazman_id,
            city_id: city_id,
            state_id: state_id,
            majmooe_id: majmooe_id,
            search: search,
            user_type: userType,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  docs: {
    activityList: {
      url: "docs/hoze-faaliat",
      config: {
        method: "GET",
      },
      handleResponse({ data }) {
        return data;
      },
      handleError: defaultHandleError,
    },
    programTypeList: {
      url: "docs/barname-type",
      config: {
        method: "GET",
      },
      handleResponse({ data }) {
        return data;
      },
      handleError: defaultHandleError,
    },
    programNameList: {
      url: "docs/onvan-barname",
      config: {
        method: "GET",
      },
      handleResponse({ data }) {
        return data;
      },
      handleError: defaultHandleError,
    },
    subjectList: {
      url: "docs/mozoue-tabiyni",
      config: {
        method: "GET",
      },
      handleResponse({ data }) {
        return data;
      },
      handleError: defaultHandleError,
    },
  },
  events: {
    permissions: {
      url: ({ eventId }) => `docs/monasebat-permission/${eventId}/`,
      config: {
        method: "GET",
      },
      input({ eventId }) {
        return {
          urlParams: {
            eventId,
          },
        };
      },
      handleResponse({ data }) {
        return {
          message: data.message,
          isAuthorize: data.can_use,
        };
      },
      handleError: defaultHandleError,
    },
    list: {
      url: "docs/monasebat",
      config: {
        method: "GET",
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  program: {
    list: {
      url: "docs/customer-programs-v2",
      config: {
        method: "GET",
      },
      input({ page, monasebat, onvan_barnameh, status }) {
        return {
          params: {
            page: page,
            status: status,
            onvan_barnameh: onvan_barnameh,
            monasebat: monasebat,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    listByAdmin: {
      url: `docs/programs-list-v2`,
      // if (user_id) {
      //   return `docs/programs-list-v2?user_id=${user_id}`;
      // } else if (event_id) {
      //   return `docs/programs-list-v2?event_id=${event_id}`;
      // } else {
      //   return `docs/programs-list-v2`;
      // }
      config: {
        method: "GET",
      },
      input({
        user_id,
        page,
        search,
        status,
        monasebat,
        user_city,
        user_majmooe,
        user_sazman,
        state,
      }) {
        return {
          params: {
            user_id: user_id,
            page: page,
            search: search,
            status: status,
            user_state: state,
            monasebat: monasebat,
            user_city: user_city,
            user_majmooe: user_majmooe,
            user_sazman: user_sazman,
          },
        };
      },
      handleResponse({ data }) {
        return data;
      },
      handleError: defaultHandleError,
    },
    lastHistory: {
      url: ({ programId }) => `docs/reply-history/${programId}/last`,
      config: {
        method: "GET",
      },
      input({ programId }) {
        return {
          urlParams: {
            programId,
          },
        };
      },
      handleResponse({ data }) {
        return data[0];
      },
      handleError: defaultHandleError,
    },
    history: {
      url: ({ programId }) => `docs/reply-history/${programId}/`,
      config: {
        method: "GET",
      },
      input({ programId }) {
        return {
          urlParams: {
            programId,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    adminReply: {
      url: "docs/admin-reply/",
      config: {
        method: "POST",
      },
      input({ programId, status, description }) {
        return {
          body: {
            description,
            program: +programId,
            program_status: status,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    questionList: {
      url: "docs/report-question/",
      config: {
        method: "GET",
      },
      input({ programNameId }) {
        return {
          params: {
            onvan_barnameh: programNameId,
            onvan_barnameh_id: programNameId,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    create: {
      url: "docs/program-create/",
      config: {
        method: "POST",
      },
      error: {
        "Cannot create more programs. Limit reached.":
          "شما بیش از ۵ برنامه از تاریخ اجرا گذشته دارید که گزارش آن را ثبت نکرده اید. لطفا نسبت به ثبت گزارش یا پاک کردن برنامه ها اقدام فرمایید.",
      },
      input({
        implementationDate,
        presenter,
        eventId,
        description,
        programType,
        subjectList,
      }) {
        return {
          body: {
            implementation_date: implementationDate,
            presenter: presenter,
            description: description,
            monasebat: eventId,
            onvan_barnameh: programType,
            mozooe_tabiyni: subjectList,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    delete: {
      url: ({ programId }) => `docs/program/${programId}`,
      config: {
        method: "DELETE",
      },
      input({ programId }) {
        return {
          body: {
            programId,
            program: programId,
          },
          urlParams: {
            programId,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    uploadImage: {
      url: "docs/image-report/",
      config: {
        method: "POST",
      },
      input({ file }) {
        return {
          formData: {
            file,
            image: file,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    answerQuestion: {
      url: "docs/report-answer/",
      config: {
        method: "POST",
      },
      input({ answer, questionId }) {
        return {
          body: {
            answer,
            question: questionId,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    reply: {
      url: "docs/reply/",
      config: {
        method: "POST",
      },
      input({
        programId,
        implementationDate,
        presenter,
        description,
        programType,
        subjectList,
        eventId,
        reportDescription,
        executionsNumber,
        hasReport,
        hasInfo,
        reportQuestions,
        reportImages,
      }) {
        return {
          body: {
            program: programId,
            info: hasInfo
              ? {
                  implementation_date: implementationDate,
                  presenter: presenter,
                  description: description,
                  onvan_barnameh: programType,
                  mozooe_tabiyni: subjectList,
                  monasebat: eventId,
                }
              : null,
            report: hasReport
              ? {
                  description: reportDescription,
                  executions_number: executionsNumber,
                  images: reportImages,
                  answer_question: reportQuestions,
                }
              : null,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  programData: {
    export: {
      url: "docs/export-program-data/",
      config: {
        method: "GET",
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  about: {
    newsList: {
      url: "about/gah-shomar/",
      config: {
        method: "GET",
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    guideList: {
      url: "about/file-report/",
      config: {
        method: "GET",
      },
      input() {
        return {
          params: {
            type: "راهنما",
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    announcementList: {
      url: "about/file-report/",
      config: {
        method: "GET",
      },
      input() {
        return {
          params: {
            type: "ابلاغیه",
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    announcementCreate: {
      url: "about/file-report/",
      config: {
        method: "POST",
      },
      input({ file, title, type, majmooe, state }) {
        return {
          formData: {
            file,
            title: title,
            type: type,
            majmooe: majmooe,
            state: state,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    instructionList: {
      url: "about/file-report/",
      config: {
        method: "GET",
      },
      input() {
        return {
          params: {
            type: "دستورالعمل",
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    announceDelete: {
      url: ({ id }) => `about/file-report/${id}`,
      config: {
        method: "DELETE",
      },
      input({ id }) {
        return {
          body: {
            id,
          },
          urlParams: {
            id,
          },
          params: {
            type: "ابلاغیه",
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    guideDelete: {
      url: ({ id }) => `about/file-report/${id}`,
      config: {
        method: "DELETE",
      },
      input({ id }) {
        return {
          body: {
            id,
          },
          urlParams: {
            id,
          },
          params: {
            type: "راهنما",
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    instraDelete: {
      url: ({ id }) => `about/file-report/${id}`,
      config: {
        method: "DELETE",
      },
      input({ id }) {
        return {
          body: {
            id,
          },
          urlParams: {
            id,
          },
          params: {
            type: "دستورالعمل",
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  contactUs: {
    list: {
      url: "about/contact-us",
      config: {
        method: "GET",
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  statistics: {
    admin: {
      url: ({ report, reportBy }) =>
        `docs/chart-statistics/?by=${reportBy}&report=${report}`,
      config: {
        method: "GET",
      },
      input({ report, reportBy }) {
        return {
          urlParams: {
            report,
            reportBy,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  statistical: {
    report: {
      url: "docs/statistical-report/",
      config: {
        method: "GET",
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  cityListByAdmin: {
    list: {
      url: "user/city-pagination/",
      config: {
        method: "GET",
      },
      input({ page }) {
        return {
          params: {
            page: page,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    delete: {
      url: ({ cityId }) => `user/city-pagination/${cityId}`,
      config: {
        method: "DELETE",
      },
      input({ cityId }) {
        return {
          body: {
            cityId,
            program: cityId,
          },
          urlParams: {
            cityId,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    addCity: {
      url: "user/city-pagination/",
      config: {
        method: "POST",
      },
      input({ city, is_active, state }) {
        return {
          body: {
            name: city,
            is_active: is_active,
            state: state,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    updateCity: {
      url: ({ id }) => `user/city-pagination/${id}/`,
      config: {
        method: "PUT",
      },
      input({ updateCity, updateIs_active, updateState, id }) {
        return {
          urlParams: {
            id,
          },
          body: {
            name: updateCity,
            is_active: updateIs_active,
            state: updateState,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  stateListByAdmin: {
    List: {
      url: "user/state-pagination/",
      config: {
        method: "GET",
      },
      input({ page }) {
        return {
          params: {
            page: page,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    delete: {
      url: ({ stateId }) => `user/state-pagination/${stateId}`,
      config: {
        method: "DELETE",
      },
      input({ stateId }) {
        return {
          body: {
            stateId,
            program: stateId,
          },
          urlParams: {
            stateId,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    addState: {
      url: "user/state-pagination/",
      config: {
        method: "POST",
      },
      input({ state, is_active }) {
        return {
          body: {
            name: state,
            is_active: is_active,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    updateState: {
      url: ({ id }) => `user/state-pagination/${id}/`,
      config: {
        method: "PUT",
      },
      input({ updateState, updateIs_active, id }) {
        return {
          urlParams: {
            id,
          },
          body: {
            name: updateState,
            is_active: updateIs_active,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  majmooeListByAdmin: {
    List: {
      url: "user/majmooe-pagination/",
      config: {
        method: "GET",
      },
      input({ page }) {
        return {
          params: {
            page: page,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    delete: {
      url: ({ majmooeId }) => `user/majmooe-pagination/${majmooeId}`,
      config: {
        method: "DELETE",
      },
      input({ majmooeId }) {
        return {
          body: {
            majmooeId,
            program: majmooeId,
          },
          urlParams: {
            majmooeId,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    addMajmooe: {
      url: "user/majmooe-pagination/",
      config: {
        method: "POST",
      },
      input({ title, dastgahType, is_active }) {
        return {
          body: {
            title: title,
            dastgah_type: dastgahType,
            is_active: is_active,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    updateMajmooe: {
      url: ({ id }) => `user/majmooe-pagination/${id}/`,
      config: {
        method: "PUT",
      },
      input({ updateMajmooe, dastgahType, updateIs_active, id }) {
        return {
          urlParams: {
            id,
          },
          body: {
            title: updateMajmooe,
            dastgah_type: dastgahType,
            is_active: updateIs_active,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  sazmanListByAdmin: {
    List: {
      url: "user/sazman-pagination/",
      config: {
        method: "GET",
      },
      input({ page }) {
        return {
          params: {
            page: page,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    delete: {
      url: ({ sazmanId }) => `user/sazman-pagination/${sazmanId}`,
      config: {
        method: "DELETE",
      },
      input({ sazmanId }) {
        return {
          body: {
            sazmanId,
            program: sazmanId,
          },
          urlParams: {
            sazmanId,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    addSazman: {
      url: "user/sazman-pagination/",
      config: {
        method: "POST",
      },
      input({ title, sakhtarDastgahType, is_active, majmooe }) {
        return {
          body: {
            title: title,
            sakhtar_dastgah_tabee_type: sakhtarDastgahType,
            is_active: is_active,
            majmooe: majmooe,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    updateSazman: {
      url: ({ id }) => `user/sazman-pagination/${id}/`,
      config: {
        method: "PUT",
      },
      input({
        updateSazman,
        sakhtarDastgahType,
        updateIs_active,
        majmooe,
        id,
      }) {
        return {
          urlParams: {
            id,
          },
          body: {
            title: updateSazman,
            sakhtar_dastgah_tabee_type: sakhtarDastgahType,
            is_active: updateIs_active,
            majmooe: majmooe,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  monasebatListByAdmin: {
    List: {
      url: "docs/monasebat-pagination/",
      config: {
        method: "GET",
      },
      input({ page }) {
        return {
          params: {
            page: page,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    delete: {
      url: ({ id }) => `docs/monasebat-pagination/${id}`,
      config: {
        method: "DELETE",
      },
      input({ id }) {
        return {
          body: {
            id,
          },
          urlParams: {
            id,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    addMonasebat: {
      url: "docs/monasebat-pagination/",
      config: {
        method: "POST",
      },
      input({
        title,
        mehvarFaaliat,
        implementationDate,
        selectedMonth,
        reportDescription,
        updateDateLimit,
        is_active,
      }) {
        return {
          body: {
            title: title,
            mehvar_faaliat: mehvarFaaliat,
            date: implementationDate,
            month: selectedMonth,
            description: reportDescription,
            date_limit_in_use_once_a_year: updateDateLimit,
            is_active: is_active,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    updateMonasebat: {
      url: ({ id }) => `docs/monasebat-pagination/${id}/`,
      config: {
        method: "PUT",
      },
      input({
        updateMonasebat,
        mehvarFaaliat,
        implementationDate,
        selectedMonth,
        reportDescription,
        updateDateLimit,
        updateIs_active,
        id,
      }) {
        return {
          urlParams: {
            id,
          },
          body: {
            title: updateMonasebat,
            mehvar_faaliat: mehvarFaaliat,
            date: implementationDate,
            month: selectedMonth,
            description: reportDescription,
            date_limit_in_use_once_a_year: updateDateLimit,
            is_active: updateIs_active,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  hozeFaaliatListByAdmin: {
    List: {
      url: "docs/hoze-faaliat-pagination/",
      config: {
        method: "GET",
      },
      input({ page }) {
        return {
          params: {
            page: page,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    delete: {
      url: ({ id }) => `docs/hoze-faaliat-pagination/${id}`,
      config: {
        method: "DELETE",
      },
      input({ id }) {
        return {
          body: {
            id,
          },
          urlParams: {
            id,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    addHozeFaaliat: {
      url: "docs/hoze-faaliat-pagination/",
      config: {
        method: "POST",
      },
      input({ title, is_active }) {
        return {
          body: {
            title: title,
            is_active: is_active,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    updateHozeFaaliat: {
      url: ({ id }) => `docs/hoze-faaliat-pagination/${id}/`,
      config: {
        method: "PUT",
      },
      input({ title, updateIs_active, id }) {
        return {
          urlParams: {
            id,
          },
          body: {
            title: title,
            is_active: updateIs_active,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  barnameListByAdmin: {
    List: {
      url: "docs/barname-type-pagination/",
      config: {
        method: "GET",
      },
      input({ page }) {
        return {
          params: {
            page: page,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    delete: {
      url: ({ id }) => `docs/barname-type-pagination/${id}`,
      config: {
        method: "DELETE",
      },
      input({ id }) {
        return {
          body: {
            id,
          },
          urlParams: {
            id,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    addBarname: {
      url: "docs/barname-type-pagination/",
      config: {
        method: "POST",
      },
      input({ title, is_active }) {
        return {
          body: {
            title: title,
            is_active: is_active,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    updateBarname: {
      url: ({ id }) => `docs/barname-type-pagination/${id}/`,
      config: {
        method: "PUT",
      },
      input({ title, updateIs_active, id }) {
        return {
          urlParams: {
            id,
          },
          body: {
            title: title,
            is_active: updateIs_active,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  onvanListByAdmin: {
    List: {
      url: "docs/onvan-barname-pagination/",
      config: {
        method: "GET",
      },
      input({ page }) {
        return {
          params: {
            page: page,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    programNameList: {
      url: "docs/onvan-barname",
      config: {
        method: "GET",
      },
      handleResponse({ data }) {
        return data;
      },
      handleError: defaultHandleError,
    },
    delete: {
      url: ({ id }) => `docs/onvan-barname-pagination/${id}`,
      config: {
        method: "DELETE",
      },
      input({ id }) {
        return {
          body: {
            id,
          },
          urlParams: {
            id,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    addOnvan: {
      url: "docs/onvan-barname-pagination/",
      config: {
        method: "POST",
      },
      input({ title, score, is_active, hozeId, barnameId }) {
        return {
          body: {
            title: title,
            score: score,
            is_active: is_active,
            hoze_faaliat: hozeId,
            barname_type: barnameId,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    updateOnvan: {
      url: ({ id }) => `docs/onvan-barname-pagination/${id}/`,
      config: {
        method: "PUT",
      },
      input({
        title,
        score,
        updateIs_active,
        updateHozeId,
        updateProgramId,
        id,
      }) {
        return {
          urlParams: {
            id,
          },
          body: {
            title: title,
            score: score,
            is_active: updateIs_active,
            hoze_faaliat: updateHozeId,
            barname_type: updateProgramId,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  mozooListByAdmin: {
    List: {
      url: "docs/mozoue-tabiyni-pagination/",
      config: {
        method: "GET",
      },
      input({ page }) {
        return {
          params: {
            page: page,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    delete: {
      url: ({ id }) => `docs/mozoue-tabiyni-pagination/${id}`,
      config: {
        method: "DELETE",
      },
      input({ id }) {
        return {
          body: {
            id,
          },
          urlParams: {
            id,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    addMozoo: {
      url: "docs/mozoue-tabiyni-pagination/",
      config: {
        method: "POST",
      },
      input({ title, is_active, barnameId }) {
        return {
          body: {
            title: title,
            is_active: is_active,
            barname_type: barnameId,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    updateMozoo: {
      url: ({ id }) => `docs/mozoue-tabiyni-pagination/${id}/`,
      config: {
        method: "PUT",
      },
      input({ title, updateIs_active, updateProgramId, id }) {
        return {
          urlParams: {
            id,
          },
          body: {
            title: title,
            is_active: updateIs_active,
            barname_type: updateProgramId,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  questionListByAdmin: {
    List: {
      url: "docs/report-question-Pagination/",
      config: {
        method: "GET",
      },
      input({ page }) {
        return {
          params: {
            page: page,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    delete: {
      url: ({ id }) => `docs/report-question-Pagination/${id}`,
      config: {
        method: "DELETE",
      },
      input({ id }) {
        return {
          body: {
            id,
          },
          urlParams: {
            id,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    addQuestin: {
      url: "docs/report-question-Pagination/",
      config: {
        method: "POST",
      },
      input({ title, is_active, onvanBarnamehId }) {
        return {
          body: {
            question: title,
            is_active: is_active,
            onvan_barnameh: onvanBarnamehId,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    updateQuestion: {
      url: ({ id }) => `docs/report-question-Pagination/${id}/`,
      config: {
        method: "PUT",
      },
      input({ title, updateIs_active, updateProgramId, id }) {
        return {
          urlParams: {
            id,
          },
          body: {
            question: title,
            is_active: updateIs_active,
            onvan_barnameh: updateProgramId,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
  media: {
    list: {
      url: "multimedia/customer-multimedia/",
      config: {
        method: "GET",
      },
      input({
        page,
        status,
        search,
        title,
        main_category,
        subcategory,
        cityId,
        majmooeId,
        sazmanId,
      }) {
        return {
          params: {
            page: page,
            status: status,
            search: search,
            title: title,
            main_category: main_category,
            subcategory: subcategory,
            city: cityId,
            majmooe: majmooeId,
            sazman: sazmanId,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    details: {
      url: ({ id }) => "multimedia/customer-multimedia/" + id,
      config: {
        method: "GET",
      },
      input({ id }) {
        return {
          params: {},
          urlParams: {
            id,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    adminDetails: {
      url: ({ id }) => "multimedia/admin-multimedia/" + id,
      config: {
        method: "GET",
      },
      input({ id }) {
        return {
          params: {},
          urlParams: {
            id,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    adminList: {
      url: "multimedia/admin-multimedia/",
      config: {
        method: "GET",
      },
      input({
        page,
        status,
        search,
        main_category,
        subcategory,
        user__city,
        user__state,
        user__majmooe,
        user__sazman,
      }) {
        return {
          params: {
            page: page,
            status: status,
            search: search,
            main_category: main_category,
            subcategory: subcategory,
            user__city: user__city,
            user__state: user__state,
            user__majmooe: user__majmooe,
            user__sazman: user__sazman,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    multimediaList: {
      url: "multimedia/dashboard-multimedia/",
      config: {
        method: "GET",
      },
      input({ page, subcategory, search }) {
        return {
          params: {
            page: page,
            subcategory_id: subcategory,
            search: search,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    subCategoryList: {
      url: "multimedia/subcategories/",
      config: {
        method: "GET",
      },
      input() {
        return {
          params: {},
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    delete: {
      url: ({ id }) => `multimedia/customer-multimedia/${id}/`,
      config: {
        method: "DELETE",
      },
      input({ id }) {
        return {
          body: {
            id,
          },
          urlParams: {
            id,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    adminDelete: {
      url: ({ id }) => `multimedia/admin-multimedia/${id}`,
      config: {
        method: "DELETE",
      },
      input({ id }) {
        return {
          body: {
            id,
          },
          urlParams: {
            id,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    create: {
      url: "multimedia/customer-multimedia/",
      config: {
        method: "POST",
      },
      input({ file, subcategory, title, monasebat }) {
        return {
          formData: {
            file,
            subcategory: subcategory,
            title: title,
            monasebat: monasebat,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    update: {
      url: ({ id }) => `multimedia/customer-multimedia/${id}/`,
      config: {
        method: "PATCH",
      },
      input({ id, subcategory, title, file }) {
        return {
          urlParams: {
            id,
          },
          formData: {
            subcategory: subcategory,
            title: title,
            ...(file && { file: file }),
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    stateReply: {
      url: ({ id }) => `multimedia/admin-multimedia/${id}/`,
      config: {
        method: "PUT",
      },
      input({ id, status, description }) {
        return {
          urlParams: {
            id,
          },
          body: {
            state_manager_status: status,
            state_manager_reply: description,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
    adminReply: {
      url: ({ id }) => `multimedia/admin-multimedia/${id}/`,
      config: {
        method: "PUT",
      },
      input({ id, status, description }) {
        return {
          urlParams: {
            id,
          },
          body: {
            admin_status: status,
            admin_reply: description,
          },
        };
      },
      handleResponse: defaultHandleResponse,
      handleError: defaultHandleError,
    },
  },
};
